import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { HXCheckbox } from "./base.styles";
import { FlexColumnDiv } from "./common.styles";
import { HXAutocomplete } from "./HXAutocomplete";
import { SemiBoldText } from "./HXDesktopPage.styles";
export const SemiBoldInlineText = styled(SemiBoldText) `
    display: inline;
`;
export const CheckboxBold = styled(HXCheckbox) `
    .MuiFormControlLabel-label {
        font-weight: ${fontWeights.BOLD};
    }
`;
export const CFRParent = styled(FlexColumnDiv) `
    max-width: 700px;
    gap: 8px;
`;
export const CFRDefault = styled(FlexColumnDiv) `
    padding-left: 42px;
    gap: 16px;
`;
export const CFRDefaultAutoComplete = styled((HXAutocomplete)).attrs({ Variant: "Outlined", size: "medium" }) `
    width: 360px;
`;
